import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { RevenueEstemateItem } from "../types";
import { loadSecurityRevenueEstimate } from "../thunks/getSecurityRevenueEstimateThunk";

export const useDisplaySecurityRevenueEstimate = (
  symbol?: string
) => {
  const storeStatistics = useSelector<
    StoreType,
    RevenueEstemateItem | undefined
  >((store) => store.data.reports.securityStatistics.displaySecurityRevenueEstimate);

  const displayedStatisticsRevenueEstimate =
    storeStatistics && storeStatistics.symbol === symbol
      ? storeStatistics
      : undefined;

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (symbol) {
      dispatch(loadSecurityRevenueEstimate( symbol));
    }
  }, [dispatch, symbol]);

  return displayedStatisticsRevenueEstimate;
};